import type { RfqRequestStage } from '../types';
import type { ProjectFileDetailStage } from './projectFileVersionGroups';

export const RFQ_REQUEST_STAGES: RfqRequestStage[] = ['concept', 'production'];

export const RFQ_REQUEST_STAGE_LABELS: Record<RfqRequestStage, string> = {
  concept: 'Concept',
  production: 'Production',
};

export const RFQ_REQUEST_STAGE_HINTS: Record<RfqRequestStage, string> = {
  concept: 'Budgetary pricing on a concept-level list — the frame may still change.',
  production: 'Firm pricing on the list suppliers will cut to.',
};

/** Rounds written before Concept / Production stored the project-file LOD. */
const LEGACY_STAGE_TO_REQUEST_STAGE: Record<string, RfqRequestStage> = {
  estimating: 'concept',
  conceptual: 'concept',
  joinery: 'production',
  supplementary_details: 'production',
};

export function isRfqRequestStage(value: unknown): value is RfqRequestStage {
  return value === 'concept' || value === 'production';
}

/** Normalize a stored stage (new or legacy LOD) to Concept / Production; undefined when unknown. */
export function normalizeRfqRequestStage(value: unknown): RfqRequestStage | undefined {
  if (isRfqRequestStage(value)) return value;
  if (typeof value === 'string' && LEGACY_STAGE_TO_REQUEST_STAGE[value]) return LEGACY_STAGE_TO_REQUEST_STAGE[value];
  return undefined;
}

/** "Concept" / "Production" for chips and email; falls back to the raw value for unknown legacy strings. */
export function rfqRequestStageLabel(value: unknown): string | undefined {
  const stage = normalizeRfqRequestStage(value);
  if (stage) return RFQ_REQUEST_STAGE_LABELS[stage];
  return typeof value === 'string' && value.trim() ? value : undefined;
}

/** Default round stage for a timber list's LOD: estimating / conceptual → Concept, joinery+ → Production. */
export function rfqRequestStageForDetailStage(stage: ProjectFileDetailStage | undefined): RfqRequestStage {
  return stage ? LEGACY_STAGE_TO_REQUEST_STAGE[stage] ?? 'concept' : 'concept';
}
